import {gsap} from "../LibrariesImport";
export default class BlockWall {
	static init() {

		const blocks = document.querySelectorAll('.block-wall-logo');
		blocks.forEach( block => {
			const pans = block.querySelectorAll('.track');
			pans.forEach( (pan, i) => {
				const item = pan.querySelector('.item:last-of-type');
				const dist = ( pan.offsetWidth - window.innerWidth );
				const rtl = i % 2 === 1;
				gsap.to(pan, {
					x: () => (rtl ? dist : -dist),
					ease: "none",
					scrollTrigger: {
						trigger: block,
						start: "top bottom",
						endTrigger: pan,
						end: "bottom top",
						scrub: 1,
						invalidateOnRefresh: true
					}
				});
			});
		});

	}

}
